import React, { lazy, Suspense, useEffect, useState } from "react";
import usePgiModules from "../../../hooks/useModules";
import CarouselMobile from "../../../components/carousel/CarouselMobile";
import { PRODUCTO_ESPECIAL, PRODUCTO_LINEA } from "../../../helpers/constants";
import { sortAndFilterProducts } from "../../../helpers/functions";
import useProduct from "../../../hooks/useProduct";

const SliderHomeReplicaPgi = lazy(() => import("./SliderHomeReplicaPgi"));
const BannerPub = lazy(() => import("../../../components/BannerPub"));
const HomeNews = lazy(() => import("../../../components/news/HomeNews"));
const ModuleBlockNews = lazy(() => import("../../../components/news/ModuleBlockNews"));

const HomePgiReplica = () => {
  const { getAllProducts, products } = useProduct();

  useEffect(() => {
    const handleScroll = () => {
      const altoDeViewPortDelCliente = document.body.clientHeight;
      let scrollTop = document.documentElement.scrollTop;
      const inRightElements = Array.from(document.getElementsByClassName("inRight"));
      const inLeftElements = Array.from(document.getElementsByClassName("inLeft"));
      const inDownElements = Array.from(document.getElementsByClassName("inDown"));
      const inUpElements = Array.from(document.getElementsByClassName("inUp"));

      const inElements = Array.from(document.getElementsByClassName("in"));

      const imgParallaxY = Array.from(document.getElementsByClassName("img-parallax-y"));
      const imgParallaxX = Array.from(document.getElementsByClassName("img-parallax-x"));
      const zoomOutElements = Array.from(document.getElementsByClassName("zoomOut"));

      inRightElements.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inRight");
          item.classList.add("fadeInRight");
        }
      });

      inLeftElements.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inLeft");
          item.classList.add("fadeInLeft");
        }
      });

      inDownElements.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inDown");
          item.classList.add("fadeInDown");
        }
      });

      inUpElements.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.3) {
          item.classList.remove("inUp");
          item.classList.add("fadeInUp");
        }
      });

      inElements.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.2) {
          item.classList.remove("in");
          item.classList.add("fadeIn");
        }
      });

      imgParallaxY.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.4) {
          item.style.transform = `translateY(${scrollTop * -0.2}px)`;
        }
      });
      imgParallaxX.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.6) {
          item.style.transform = `scale(${scrollTop * -0.2})`;
        }
      });

      zoomOutElements.map((item, index) => {
        if (item.getBoundingClientRect().top < altoDeViewPortDelCliente * 0.2) {
          item.classList.remove("zoomOut");
          item.classList.add("fadeZoomOut");
        }
      });
      // console.log("scroll top", scrollTop);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const { getModulesByParams, modules } = usePgiModules();
  const [homeModules, setHomeModules] = useState([]);

  useEffect(() => {
    getModulesByParams({ state: true }).then((res) => {
      setHomeModules(res.sort((a, b) => a.position - b.position));
    });
    getAllProducts({ onlyTitleAndIcon: true, visible: true });
  }, []);

  return (
    <>
      <Suspense fallback={<div> </div>}>
        <SliderHomeReplicaPgi />
        {modules.map((item, index) => {
          switch (item.title) {
            case "Carrousel_deLinea":
              if (item.visible.includes("home")) {
                return (
                  <section key={index} id="modulo-prod-linea-home" className="modul container">
                    <CarouselMobile isHomePgiReplicaPage isProductoEspecial products={sortAndFilterProducts(products, PRODUCTO_ESPECIAL)}/>
                  </section>
                );
              }
              break;
            case "Carrousel_especial":
              if (item.visible.includes("home")) {
                return (
                  <section
                    key={index}
                    id="modulo-prod-especial-home"
                    className="modul container mb-5"
                  >
                    <CarouselMobile isHomePgiReplicaPage products={sortAndFilterProducts(products, PRODUCTO_LINEA)}/>
                  </section>
                );
              }
              break;
            case "Banner_publicitario":
              if (item.visible.includes("home")) {
                return <BannerPub key={index} idProducto={"home"} />;
              }
              break;
            case "TensoNews":
              if (item.visible.includes("home")) {
                return <HomeNews key={index} editPgi={true} />;
              }
              break;
            case "Bloque_info":
              if (item.visible.includes("home")) {
                return <ModuleBlockNews key={index} editPgi={true} idProducto={"home"} />;
              }
              break;
            default:
          }
        })}
      </Suspense>
    </>
  );
};

export default HomePgiReplica;
